/**
 * 侧边Tab的key枚举
 * 单独抽出来，解决和LocalStorageUtils加载时序问题
 */
export enum SideTabKey {
    BOT = "Bot",
    MANUAL = "Manual",
    SWAP = "Swap",
}
